const pagesRequiringAuthorization: string[] = ['membre', 'followers']

export { pagesRequiringAuthorization }
